module.exports = __webpack_public_path__ + "img/icon_shop_classify_pre.8d25742e.png";